import React, { useEffect, useState } from "react"
import { useShallow } from "zustand/react/shallow"

// components
import CharCounter from "components/CharCounter/CharCounter"
import Label from "components/Label/Label"
import Note from "components/Note/Note"
import { TextInput } from "components-design-system"

// hoc
import InputWrapper from "../../hoc/InputWrapper/InputWrapper"
import { PrimeButton } from "components-design-system"
import useAuthoringViewStore from "containers/studies/Study/subcomponents/Authoring/hooks/stores/useAuthoringViewStore"
import "./RJTypeUnitsAssigned.scss"

const RJTypeUnitsAssigned = (props) => {
  let { id, carbonProps, invalid, invalidText, value, onChange, onFocus, onBlur } = props
  const [showField, setShowField] = useState(false)

  const { readOnly } = useAuthoringViewStore(
    useShallow((state) => ({
      readOnly: state.readOnly,
    }))
  )

  useEffect(() => {
    if (value) setShowField(true)
  }, [])

  const handleButton = () => {
    if (showField) {
      onChange("")
      setShowField(false)
    } else {
      setShowField(true)
    }
  }

  return (
    <div className="pf-type-units-assigned">
      {showField === true && (
        <TextInput
          id={id + "-field"}
          className={"rjs-widget"}
          disabled={carbonProps.disabled}
          readonly={readOnly}
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          onFocus={onFocus}
          onBlur={onBlur}
        />
      )}
      {carbonProps.charCountEnabledFieldLevel && showField && !readOnly && (
        <div className="field-helpers">
          <CharCounter
            maxChars={carbonProps?.maxChars}
            value={value}
          />
        </div>
      )}
      {invalid && (
        <Note
          type="error"
          text={invalidText}
          style={{ marginTop: 4 }}
        />
      )}
      <PrimeButton
        type={showField ? "minus" : "add"}
        size="small"
        style={{
          marginTop: 8,
          marginBottom: 8,
        }}
        onClick={handleButton}
      >
        {showField ? "Delete Units" : "Add Units"}
      </PrimeButton>
      <Label>Note: Only use if units other than participants are assigned (e.g., eyes, lesions, implants)</Label>
    </div>
  )
}

export default InputWrapper(RJTypeUnitsAssigned)
